/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Lab } from '../../models/lab';

export interface LabsGetGraphForlab$Params {
  EmrpracticeId?: string | null;
  PatientId?: string | null;
  SelectedTest?: string | null;
  Labname?: string | null;
}

export function labsGetGraphForlab(http: HttpClient, rootUrl: string, params?: LabsGetGraphForlab$Params, context?: HttpContext): Observable<StrictHttpResponse<Lab>> {
  const rb = new RequestBuilder(rootUrl, labsGetGraphForlab.PATH, 'get');
  if (params) {
    rb.query('EmrpracticeId', params.EmrpracticeId, {});
    rb.query('PatientId', params.PatientId, {});
    rb.query('SelectedTest', params.SelectedTest, {});
    rb.query('Labname', params.Labname, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Lab>;
    })
  );
}

labsGetGraphForlab.PATH = '/lab/getlabgraph';
